export const productDetail = {
  notFound: {
    title: 'Product Not Found',
    returnToProducts: 'Return to Products',
  },
  breadcrumb: {
    products: 'Products',
  },
  backButton: 'Back to Category',
  partnerBadge: 'Partner',
  categoryBadge: 'Category',
  keyFeatures: {
    title: 'Key Features',
  },
  actions: {
    downloadSheet: 'Download Technical Sheet',
    requestQuote: 'Request Quote',
  },
  specifications: {
    title: 'Technical Specifications',
  },
  applications: {
    title: 'Applications',
  },
  industries: {
    title: 'Industries',
  },
  benefits: {
    title: 'Why Choose This Product?',
  },
  relatedProducts: {
    title: 'Related Products',
    viewDetails: 'View Details',
  },
  cta: {
    title: 'Ready to Implement This Solution?',
    subtitle: 'Our technical experts are ready to help you integrate this product into your industrial processes. Get personalized consultation and technical support.',
    requestStudy: 'Request Technical Study',
    contactTeam: 'Contact Our Team',
  },
};